/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the HomerunConnectionConfig interface.
 */
export function instanceOfHomerunConnectionConfig(value) {
    if (!('isJobImportEnabled' in value) || value['isJobImportEnabled'] === undefined)
        return false;
    if (!('isCandidateExportEnabled' in value) || value['isCandidateExportEnabled'] === undefined)
        return false;
    return true;
}
export function HomerunConnectionConfigFromJSON(json) {
    return HomerunConnectionConfigFromJSONTyped(json, false);
}
export function HomerunConnectionConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'isJobImportEnabled': json['isJobImportEnabled'],
        'isCandidateExportEnabled': json['isCandidateExportEnabled'],
    };
}
export function HomerunConnectionConfigToJSON(json) {
    return HomerunConnectionConfigToJSONTyped(json, false);
}
export function HomerunConnectionConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'isJobImportEnabled': value['isJobImportEnabled'],
        'isCandidateExportEnabled': value['isCandidateExportEnabled'],
    };
}
